import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';

const getDocHeight = (doc) => {
  return Math.max(
    Math.max(doc.body.scrollHeight, doc.documentElement.scrollHeight),
    Math.max(doc.body.offsetHeight, doc.documentElement.offsetHeight),
    Math.max(doc.body.clientHeight, doc.documentElement.clientHeight),
  );
};

/**
 * Renders a form to an iframe.
 *
 * @param document the review document
 * @return {JSX.Element}
 */
const FormViewer = ({ document }) => {
  const iframeRef = useRef();

  useEffect(() => {
    const iframe = iframeRef.current;

    if (iframe) {
      iframe.addEventListener('load', () => {
        const extraPadding = 10;

        iframe.height = `${getDocHeight(iframe.contentWindow.document) + extraPadding}px`;

        iframe.contentWindow.addEventListener('resize', () => {
          iframe.height = `${getDocHeight(iframe.contentWindow.document)}px`;
        });
      });
    }
  }, [iframeRef.current]);

  return (
    <div className="review-form-viewer">
      <iframe
        ref={iframeRef}
        src={document.document_url}
        className="review-documents-form"
        style={{ width: '100%' }}
        frameBorder={0}
      />
    </div>
  );
};

FormViewer.propTypes = {
  document: PropTypes.shape({
    document_url: PropTypes.string,
  })
};

export default FormViewer;
